import { fundsReport, UPIDetails, producteWiseBalance, peridiocityWiseBalanceAndType, peridiocityWiseBalance, fundTransferMappedProduct, mktAllowed, mandateReport, bankList, mappedBanksList, fundsWithdrawal, fundsTransfer, availableBankList, fundsWithdrawalCancellation } from "../../apis/transactional";
import { _getFormatedData, _getPeriodicities } from "../../controllers/funds";
import { FUNDS } from "../actionTypes";
import { GetNonBusinessDays } from "../../apis/nontransactional";

export const getFundsReport = (startDate, endDate) => async (dispatch, getState) => {
    try {
        dispatch(getFundsReportPendingState(true));
        const objResp = await fundsReport(startDate, endDate);   // Hari K:06-11-2023 :BT-119138:Funds View- removed unnecessary code
        dispatch(getFundsReportSuccess(objResp?.data?.data));
        dispatch(getFundsReportPendingState(false));
    } catch (error) {
        dispatch(getFundsReportPendingState(false));
        console.log(error.message);
        if (error?.response?.data) {
            dispatch(getFundsReportFailure(error?.response?.data));
        } else {
            dispatch(getFundsReportFailure({}));
        }
    }
};

export const getFundsReportPendingState = (payload) => {
    return { type: FUNDS.GET_TRANSACTION_PENDING_STATE, payload };
};
export const getFundsReportSuccess = (payload) => {
    return { type: FUNDS.FUNDS_REPORT_SUCCESS, payload };
};

export const getFundsReportFailure = (payload) => {
    return { type: FUNDS.FUNDS_REPORT_FAILURE, payload };
};



export const getPeridiocityWiseBalance = () => async (dispatch, getState) => {
    try {
        dispatch(getPeridiocityWiseBalancePendingState(true));
        const objResp = await peridiocityWiseBalance();
        const arrObj = objResp.data.data;
        const arrFormatedPeriodiocies = arrObj.map((each) => {
            const objFormatedData = _getFormatedData(each.data);   // Hari K:06-11-2023 :BT-119138:Funds View - removed unnecessary code
            return {
                ...each,
                data: objFormatedData.arrCategorizedFunds,
                arrIndividualFundsItems: objFormatedData.arrIndividualFundsItems
            };
        });
        dispatch(getPeridiocityWiseBalancePendingState(false));
        dispatch(getPeridiocityWiseBalanceSuccess(arrFormatedPeriodiocies));
        return Promise.resolve(objResp.data.data);
    } catch (error) {
        dispatch(getPeridiocityWiseBalancePendingState(false));
        console.error(error.message);
        if (error?.response?.data) {
            dispatch(getPeridiocityWiseBalanceFailure(error?.response?.data));
        } else {
            dispatch(getPeridiocityWiseBalanceFailure([]));
        }
        return Promise.reject(error);
    }
};

export const setPeridiocityWiseFundsBreakup = (payload) => {
    return { type: FUNDS.SET_PERIODIOCITY_WISE_FUNDS_BREAKUP, payload };
};

export const getPeridiocityWiseBalancePendingState = (payload) => {
    return { type: FUNDS.GET_PERIODICITY_WISE_BALACE_PENDING_STATE, payload };
};
export const getPeridiocityWiseBalanceSuccess = (payload) => {
    return { type: FUNDS.PERIODIOCITY_WISE_BALANCE_SUCCESS, payload };
};

export const getPeridiocityWiseBalanceFailure = (payload) => {
    return { type: FUNDS.PERIODIOCITY_WISE_BALANCE_FAILURE, payload };
};



export const getUPIDetails = (objPayload = {}) => async (dispatch, getState) => { // Hari K:10-11-2023: changed function name

    try {
        const objResp = await UPIDetails(objPayload);
        dispatch(getUPIDetailsSuccess(objResp.data.data));
    } catch (error) {
        console.error(error.message);
        if (error?.response?.data) {
            dispatch(getUPIDetailsFailure(error?.response?.data));
        } else {
            dispatch(getUPIDetailsFailure({}));
        }
    }
};



export const getUPIDetailsSuccess = (payload) => { // Hari K:10-11-2023: changed function name
    return { type: FUNDS.UPI_DETAILS_SUCCESS, payload };
};

export const getUPIDetailsFailure = (payload) => {  // Hari K:10-11-2023: changed function name
    return { type: FUNDS.UPI_DETAILS_FAILURE, payload };
};

export const getPeriodicities = () => async (dispatch) => {
    try {
        const objResp = await _getPeriodicities();
        if (objResp?.status) {
            dispatch(getPeriodicitiesSuccess(objResp?.data?.data));
        } else {
            console.error(objResp?.data);
            dispatch(getPeriodicitiesFailure(null));
        }
    } catch (error) {
        dispatch(getPeriodicitiesFailure({}));
    }
};




export const getPeriodicitiesSuccess = (payload) => {
    return { type: FUNDS.GET_PERIODIOCITIES_SUCCESS, payload };
};

export const getPeriodicitiesFailure = (payload) => {
    return { type: FUNDS.GET_PERIODIOCITIES_FAILURE, payload };
};



export const getPeridiocityWiseBalanceAndType = (peridiocity, type) => async (dispatch, getState) => {
    try {
        const objResp = await peridiocityWiseBalanceAndType({ peridiocity: peridiocity, type: type });
        dispatch(getPeridiocityWiseBalanceAndTypeSuccess(objResp.data));
    } catch (error) {
        console.error(error.message);
        if (error?.response?.data) {
            dispatch(getPeridiocityWiseBalanceAndTypeFailure(error?.response?.data));
        } else {
            dispatch(getPeridiocityWiseBalanceAndTypeFailure({}));
        }
    }
};

export const getPeridiocityWiseBalanceAndTypeSuccess = (payload) => {
    return { type: FUNDS.PERIODIOCITY_WISE_BALANCE_TYPE_SUCCESS, payload };
};

export const getPeridiocityWiseBalanceAndTypeFailure = (payload) => {
    return { type: FUNDS.PERIODIOCITY_WISE_BALANCE_TYPE_FAILURE, payload };
};

export const getproducteWiseBalance = (objPayload = {}) => async (dispatch, getState) => {
    try {
        const objResp = await producteWiseBalance(objPayload);
        const activeProductiveWiseBalances = objResp?.data?.data.filter((each) => each.sActive === 1);
        dispatch(getproducteWiseBalanceSuccess(activeProductiveWiseBalances));
    } catch (error) {
        console.error(error.message);
        if (error?.response?.data) {
            dispatch(getproducteWiseBalanceFailure(error?.response?.data));
        } else {
            dispatch(getproducteWiseBalanceFailure({}));
        }
    }
};

export const getproducteWiseBalanceSuccess = (payload) => {
    return { type: FUNDS.PRODUCT_WISE_BALANCE_SUCCESS, payload };
};

export const getproducteWiseBalanceFailure = (payload) => {
    return { type: FUNDS.PRODUCT_WISE_BALANCE_FAILURE, payload };
};

//Hari k:06-11-2023:BT-119138:funds-views-start
export const getMktAllowed = (nMarket) => async (dispatch, getState) => {
    try {
        const objResp = await mktAllowed(nMarket);
        dispatch(getMktAllowedSuccess(objResp?.data?.data));
        return Promise.resolve(objResp?.data?.data);
    } catch (error) {
        console.error(error?.message);
        if (error?.response?.data) {
            dispatch(getMktAllowedFailure(error?.response?.data));
        } else {
            dispatch(getMktAllowedFailure({}));
        }
        return Promise.reject(error);
    }
};

export const getMktAllowedSuccess = (payload) => {
    return { type: FUNDS.GET_ALLOWED_MARKETS_SUCCESS, payload };
};

export const getMktAllowedFailure = (payload) => {
    return { type: FUNDS.GET_ALLOWED_MARKETS_FAILURE, payload };
};


export const getMandateReport = () => async (dispatch, getState) => {
    try {
        const objResp = await mandateReport();
        dispatch(getMandateReportSuccess(objResp.data));
    } catch (error) {
        console.error(error.message);
        if (error?.response?.data) {
            dispatch(getMandateReportFailure(error?.response?.data));
        } else {
            dispatch(getMandateReportFailure());
        }
    }
};

export const getMandateReportSuccess = (payload) => {
    return { type: FUNDS.GET_MANDATE_DETAILS_SUCCESS, payload };
};
export const getMandateReportFailure = (payload) => {
    return { type: FUNDS.GET_MANDATE_DETAILS_FAILURE, payload };
};



export const getBankList = () => async (dispatch, getState) => {
    try {
        const objResp = await bankList();
        dispatch(getBankListSuccess(objResp.data.data));
    } catch (error) {
        console.error(error.message);
        if (error?.response?.data) {
            dispatch(getBankListFailure(error?.response?.data));
        } else {
            dispatch(getBankListFailure());
        }
    }
};

export const getBankListSuccess = (payload) => {
    return { type: FUNDS.GET_BANK_ACCOUNTS_LIST_SUCCESS, payload };
};
export const getBankListFailure = (payload) => {
    return { type: FUNDS.GET_BANK_ACCOUNTS_LIST_FAILURE, payload };
};


export const getmappedBanksList = (product, bank) => async (dispatch, getState) => {
    try {
        const objResp = await mappedBanksList({ product: product, bank: bank });
        dispatch(getmappedBanksListSuccess(objResp.data.data));
        return Promise.resolve(objResp.data.data);
    } catch (error) {
        console.error(error.message);
        if (error?.response?.data) {
            dispatch(getmappedBanksListFailure(error?.response?.data));
        } else {
            dispatch(getmappedBanksListFailure());
        }
    }
};


export const getmappedBanksListSuccess = (payload) => {
    return { type: FUNDS.GET_MANDATE_DETAILS_SUCCESS, payload };
};
export const getmappedBanksListFailure = (payload) => {
    return { type: FUNDS.GET_MANDATE_DETAILS_FAILURE, payload };
};



export const getFundsWithdrawal = (objPayload) => async (dispatch, getState) => {
    try {
        const objResp = await fundsWithdrawal(objPayload);
        dispatch(getFundsWithdrawalSuccess(objResp.data.data));
        return Promise.resolve(objResp.data.data);
    } catch (error) {
        console.error(error.message);
        if (error?.response?.data) {
            dispatch(getFundsWithdrawalFailure(error?.response?.data));
        } else {
            dispatch(getFundsWithdrawalFailure());
        }
        return Promise.reject(error);
    }
};

export const getFundsWithdrawalSuccess = (payload) => {
    return { type: FUNDS.WITHDRAWAL_SUCCESS, payload };
};
export const getFundsWithdrawalFailure = (payload) => {
    return { type: FUNDS.WITHDRAWAL_FAILURE, payload };
};


export const getFundsTransfer = (objPayload) => async (dispatch, getState) => {
    try {
        const objResp = await fundsTransfer(objPayload);
        dispatch(getFundsTransferSuccess(objResp.data.data));
        return Promise.resolve(objResp.data.data);
    } catch (error) {
        console.error(error.message);
        if (error?.response?.data) {
            dispatch(getFundsTransferFailure(error?.response?.data));
        } else {
            dispatch(getFundsTransferFailure());
        }
        return Promise.reject(error);
    }
};

export const getFundsTransferSuccess = (payload) => {
    return { type: FUNDS.TRANSFER_FUNDS_SUCCESS, payload };
};
export const getFundsTransferFailure = (payload) => {
    return { type: FUNDS.TRANSFER_FUNDS_FAILURE, payload };
};

//Hari k:06-11-2023:BT-119138:funds-views-end


export const getFundTransferMappedProduct = (objPayload) => async (dispatch, getState) => {
    try {
        const objResp = await fundTransferMappedProduct(objPayload);
        dispatch(getFundTransferMappedProductSuccess(objResp.data.data));
    } catch (error) {
        console.error(error.message);
        if (error?.response?.data) {
            dispatch(getFundTransferMappedProductFailure(error?.response?.data));
        } else {
            dispatch(getFundTransferMappedProductFailure({}));
        }
    }
};

export const getFundTransferMappedProductSuccess = (payload) => {
    return { type: FUNDS.TRANSFER_MAPPED_PRODUCTS_SUCCESS, payload };
};

export const getFundTransferMappedProductFailure = (payload) => {
    return { type: FUNDS.TRANSFER_MAPPED_PRODUCTS_FAILURE, payload };
};

// Hari K:22-02-2023 :BT-119138:Funds View-start
export const nonBusinessDays = () => async (dispatch, getState) => {
    try {
        const objResp = await GetNonBusinessDays();
        dispatch(nonBusinessDaysSuccess(objResp.data.result));
    } catch (error) {
        console.error(error.message);
        if (error?.response?.data) {
            dispatch(nonBusinessDaysFailure(error?.response?.data));
        } else {
            dispatch(nonBusinessDaysFailure({}));
        }
    }
};

export const nonBusinessDaysSuccess = (payload) => {
    return { type: FUNDS.GET_NON_BUSINESS_SUCCESS, payload };
};

export const nonBusinessDaysFailure = (payload) => {
    return { type: FUNDS.GET_NON_BUSINESS_FAILURE, payload };
};

export const getAvailableBankList = () => async (dispatch, getState) => {
    try {
        const objResp = await availableBankList();
        dispatch(getAvailableBankListSuccess(objResp.data.data));
    } catch (error) {
        console.error(error.message);
        if (error?.response?.data) {
            dispatch(getAvailableBankListFailure(error?.response?.data));
        } else {
            dispatch(getAvailableBankListFailure({}));
        }
    }
};

export const getAvailableBankListSuccess = (payload) => {
    return { type: FUNDS.GET_AVAILABLE_BANK_LIST_SUCCESS, payload };
};

export const getAvailableBankListFailure = (payload) => {
    return { type: FUNDS.GET_AVAILABLE_BANK_LIST_FAILURE, payload };
};
// Hari K:22-02-2023 :BT-119138:Funds View-start

export const getFundsWithdrawalCancellation = (payload) => async (dispatch, getState) => {
    try {
        const objResp = await fundsWithdrawalCancellation(payload);
        dispatch(getFundsWithdrawalCancellationSuccess(objResp.data.data));
        return Promise.resolve(objResp.data.data);
    } catch (error) {
        console.log(error.message);
        if (error?.response?.data) {
            dispatch(getFundsWithdrawalCancellationFailure(error?.response?.data));
        } else {
            dispatch(getFundsWithdrawalCancellationFailure({}));
        }
        return Promise.reject(error);
    }
};

export const getFundsWithdrawalCancellationSuccess = (payload) => {
    return { type: FUNDS.WITHDRAWAL_FUNDS_CANCEL_SUCCESS, payload };
};

export const getFundsWithdrawalCancellationFailure = (payload) => {
    return { type: FUNDS.WITHDRAWAL_FUNDS_CANCEL_FAILURE, payload };
};

export const getFunds = () => {
    return { type: FUNDS.GET_FUNDS, payload: {} };
};

export const getFundsBreakups = () => {
    return { type: FUNDS.GET_FUNDS_BREAKUPS, payload: {} };
};
export const getTransactionListsGrid = () => {
    return { type: FUNDS.GET_TRANSACTIONLIST_GRID, payload: {} };
};


export const marginDetail = (payload) => {
    return { type: FUNDS.GET_MARGIN_DETAILS, payload: {} };
};

export const balanceInfo = (payload) => {
    return { type: FUNDS.GET_BALANCE_SUMMURY, payload: {} };
};
